"use client";

import React, { ReactNode } from "react";
import styled from "styled-components";
import { blockPaddingBottom, Box } from "@motorata/base-ui.components.atoms._atoms";
import NewsletterSection from "@/components/sections/NewsletterSection";
import FooterSection from "@/components/shared/FooterSection";
import RentSection from "@/components/sections/RentSection";
import AdvantagesSection from "@/components/sections/AdvantagesSection";

export default function ProfileTemplate({ header, sidebar, offers }: {
  header: ReactNode
  sidebar: ReactNode
  offers: ReactNode
}) {

  return <>
    <Wrapper>
      {header}
      <Box className="background">
        <Content>
          {sidebar}
          {offers}
        </Content>
      </Box>
    </Wrapper>
    <RentSection />
    <FooterSection>
      <AdvantagesSection />
      <NewsletterSection />
    </FooterSection>
  </>;
}

const Content = styled.div`
  ${blockPaddingBottom};
  padding-top: ${({ theme }) => theme.space.M};
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-gap: ${({ theme }) => theme.space.M};

  @media (max-width: 1200px) {
    display: block;
  }
`;


const Wrapper = styled(Box)`
  max-width: 1300px;
  margin: 0 auto;
`;
